export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_INITIALIZE = 'ACCOUNT_INITIALIZE';
export const SET_SUB_RENEW_DATA = 'SET_SUB_RENEW_DATA';
